<template>
  <div class="dialog">
    <el-dialog title="编辑用户" :visible.sync="isDialog" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="dialogForm">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <div> {{ item.userName }} </div>
        </el-form-item>
        <el-form-item label="修改角色" :label-width="formLabelWidth">
          <el-select v-model="dialogForm.roleId" placeholder="请选择">
            <el-option v-for="item in roleOption" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="修改密码" :label-width="formLabelWidth">
          <el-input v-model="dialogForm.password" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm(item)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    roleOption: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      formLabelWidth: '120px',
      dialogForm: {
        password: '',
        roleId: ''
      },
      options: [
        {
          id: 1,
          value: '超级管理员',
          label: '超级管理员'
        },
        {
          id: 2,
          value: '普通管理员',
          label: '普通管理员'
        },
      ]
    }
  },
  methods: {
    // 确定
    handleConfirm (item) {
      const params = {
        userId: item.userId,
        password: this.dialogForm.password,
        roleId: this.dialogForm.roleId
      }
      this.$emit('handleConfirm', params)
    },
    // 取消
    handleCancel () {
      this.$emit('handleCancel', false)
    }
  },
  watch: {
    isDialog () {
      console.log(this.isDialog, "90909090909090909090909090909090")
    }
  }
}
</script>

<style></style>